<div class="page">
  <div class="content-shell" [class.drawer-open]="!!selectedTicket">
   <div class="panel">
    @if (loader.message) {
      <div class="loader-class" aria-live="polite">
        <mat-spinner diameter="28"></mat-spinner>
        <div class="loader-message">{{ loader.message }}</div>
      </div>
    }
    
    <div class="panel-header">
      <div>
        <h2>All Tickets</h2>
        <p>{{ totalCount }} tickets</p>
      </div>
      <div class="toolbar">
        <button class="btn ghost" type="button" (click)="toggleFilters()">
          <span>☰</span>
          Filters
        </button>
        <button class="btn primary" type="button" (click)="exportTickets()"
          [disabled]="loader.isLoading">
          <span>↓</span>
          Export
        </button>
      </div>
    </div>

    @if (showFilters) {
      <div class="filters">
        <label class="filter-field">
          <span class="filter-label">Search</span>
          <label class="search">
            <span class="icon">⌕</span>
            <input type="text" [(ngModel)]="searchTitle"
              placeholder="Search tickets..." aria-label="Search tickets"/>
            <button class="search-go-btn" type="button" aria-label="Apply title search"
              (click)="onFilterChange()" [disabled]="loader.isLoading">
              ➜
            </button>
          </label>
        </label>
        <label class="filter-field">
          <span class="filter-label">Status</span>
          <select [(ngModel)]="selectedStatusId" (change)="onFilterChange()">
            <option [ngValue]="null">All statuses</option>
            @for (s of statusOptions; track s.id) {
              <option [ngValue]="s.id">{{ s.name }}</option>
            }
          </select>
        </label>
        <label class="filter-field">
          <span class="filter-label">Request Type</span>
          <select [(ngModel)]="selectedRequestTypeId" (change)="onFilterChange()">
            <option [ngValue]="null">All request types</option>
            @for (c of requestTypeOptions; track c.id) {
              <option [ngValue]="c.id">{{ c.name }}</option>
            }
          </select>
        </label>
        <label class="filter-field">
          <span class="filter-label">Application</span>
          <select [(ngModel)]="selectedApplicationId" (change)="onFilterChange()">
            <option [ngValue]="null">All applications</option>
            @for (a of applicationOptions; track a.id) {
              <option [ngValue]="a.id">{{ a.name }}</option>
            }
          </select>
        </label>
        <label class="filter-field">
          <span class="filter-label">Version</span>
          <select [(ngModel)]="selectedVersionId" (change)="onFilterChange()">
            <option [ngValue]="null">All versions</option>
            @for (v of versionOptions; track v.id) {
              <option [ngValue]="v.id">{{ v.name }}</option>
            }
          </select>
        </label>
        <div class="filter-field">
          <span class="filter-label">Submitted</span>
          <p-datepicker [(ngModel)]="selectedDateRange"
            selectionMode="range" [showButtonBar]="true"
            [readonlyInput]="true" placeholder="Select date or range"
            dateFormat="yy-mm-dd" appendTo="body"
            (onSelect)="onDateRangeChange()"
            (onClearClick)="onFilterChange()"></p-datepicker>
        </div>
        <button class="btn subtle" type="button" (click)="clearFilters()">
          Clear
        </button>
      </div>
    }

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th class="ticket-col">Ticket</th>
            <th class="status-col">
              <button class="sort-header" type="button" (click)="onSortColumnClick('status_id')" [class.active]="isSortActive('status_id')">
                <span>Status</span>
                <span class="sort-icons" aria-hidden="true">
                  <span class="sort-up" [class.active]="isSortActive('status_id') && selectedSortOrder === 'ASC'">▲</span>
                  <span class="sort-down" [class.active]="isSortActive('status_id') && selectedSortOrder === 'DESC'">▼</span>
                </span>
              </button>
            </th>
            @if (showUseCase) {
              <th>Use Case</th>
            }
            <th>
              <button class="sort-header" type="button" (click)="onSortColumnClick('workcategorytype_id')" [class.active]="isSortActive('workcategorytype_id')">
                <span>Request Type</span>
                <span class="sort-icons" aria-hidden="true">
                  <span class="sort-up" [class.active]="isSortActive('workcategorytype_id') && selectedSortOrder === 'ASC'">▲</span>
                  <span class="sort-down" [class.active]="isSortActive('workcategorytype_id') && selectedSortOrder === 'DESC'">▼</span>
                </span>
              </button>
            </th>
            <th>
              <button class="sort-header" type="button" (click)="onSortColumnClick('application_id')" [class.active]="isSortActive('application_id')">
                <span>Application</span>
                <span class="sort-icons" aria-hidden="true">
                  <span class="sort-up" [class.active]="isSortActive('application_id') && selectedSortOrder === 'ASC'">▲</span>
                  <span class="sort-down" [class.active]="isSortActive('application_id') && selectedSortOrder === 'DESC'">▼</span>
                </span>
              </button>
            </th>
            <th>
              <button class="sort-header" type="button" (click)="onSortColumnClick('version_id')" [class.active]="isSortActive('version_id')">
                <span>Version</span>
                <span class="sort-icons" aria-hidden="true">
                  <span class="sort-up" [class.active]="isSortActive('version_id') && selectedSortOrder === 'ASC'">▲</span>
                  <span class="sort-down" [class.active]="isSortActive('version_id') && selectedSortOrder === 'DESC'">▼</span>
                </span>
              </button>
            </th>
            <th>Team</th>
            <th>Submitter</th>
            <th>
              <button class="sort-header" type="button" (click)="onSortColumnClick('creation_date')" [class.active]="isSortActive('creation_date')">
                <span>Submitted</span>
                <span class="sort-icons" aria-hidden="true">
                  <span class="sort-up" [class.active]="isSortActive('creation_date') && selectedSortOrder === 'ASC'">▲</span>
                  <span class="sort-down" [class.active]="isSortActive('creation_date') && selectedSortOrder === 'DESC'">▼</span>
                </span>
              </button>
            </th>
            <th>Votes</th>
            <th class="actions-col">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (ticket of tickets; track ticket.id) {
            <tr
              [class.selected-row]="selectedTicket?.id === ticket.id"
              tabindex="0" (click)="openTicketPreview(ticket)" (keydown.enter)="openTicketPreview(ticket)">
              <td class="ticket-col">
                <div class="ticket-meta">
                  <div class="ticket-id">{{ ticket.id }}</div>
                  <div class="ticket-title">{{ ticket.title }}</div>
                  <div class="ticket-updated">Updated {{ ticket.updated }}</div>
                </div>
              </td>
              <td class="status-col">
                <span class="badge pill" [class]="statusClass(ticket.status)">{{ ticket.status }}</span>
              </td>
              @if (showUseCase) {
                <td>
                  <span class="column-text">{{ ticket.useCase }}</span>
                </td>
              }
              <td>
                <span class="column-text">{{ ticket.requestType }}</span>
              </td>
              <td>
                <span class="column-text">{{ ticket.application }}</span>
              </td>
              <td>
                <span class="column-text">{{ ticket.version }}</span>
              </td>
              <td>
                <span class="team-pill">{{ ticket.team }}</span>
              </td>
              <td class="muted">{{ ticket.requestedUser }}</td>
              <td class="muted">{{ ticket.submitted }}</td>
              <td>
                <div class="votes">
                  <span class="vote-pill" [class.liked]="ticket.liked">👍 {{ ticket.likesCount }}</span>
                  <span class="vote-pill">💬 {{ ticket.commentCount }}</span>
                </div>
              </td>
              <td class="actions-col">
                <button class="btn icon-btn" type="button" aria-label="More actions"
                  (click)="openTicketPreview(ticket)">
                  ⋮
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (tickets.length === 0) {
        <div class="empty">
          @if (loader.isLoading) {
            Loading data...
          }
          @else {
            No tickets match your filters.
          }
        </div>
      }
    </div>

    <div class="footer">
      <div class="muted">
        Showing {{ pageStart }} to {{ pageEnd }} of {{ totalCount }} tickets
      </div>
      <div class="pagination">
        <button class="page-btn" type="button" aria-label="First page" (click)="firstPage()"
          [disabled]="page === 1 || loader.isLoading"><i class="pi pi-angle-double-left" aria-hidden="true"></i></button>
        <button class="page-btn" type="button" aria-label="Previous page" (click)="prevPage()" 
          [disabled]="page === 1 || loader.isLoading"><i class="pi pi-angle-left" aria-hidden="true"></i></button>
        @for (pageNumber of pageNumbers; track pageNumber) {
          <button class="page-number" [disabled]="loader.isLoading"
            [class.active]="pageNumber === page" type="button"
            (click)="goToPage(pageNumber)">
            {{ pageNumber }}
          </button>
        }
        <button class="page-btn" type="button" aria-label="Next page" (click)="nextPage()"
          [disabled]="page >= totalPages || loader.isLoading"><i class="pi pi-angle-right" aria-hidden="true"></i></button>
        <button class="page-btn" type="button" aria-label="Last page" (click)="lastPage()"
          [disabled]="page >= totalPages || loader.isLoading"><i class="pi pi-angle-double-right" aria-hidden="true"></i></button>
      </div>
      <div class="rows">
        <span class="muted">Rows per page</span>
        <select [(ngModel)]="rowsPerPage" (change)="onRowsPerPageChange()" [disabled]="loader.isLoading">
          @for (rowsPerPage of rowsPerPageOptions; track rowsPerPage) {
            <option [ngValue]="rowsPerPage">{{ rowsPerPage }}</option>
          }
        </select>
      </div>
    </div>
   </div>

    @if (selectedTicket; as ticket) {
      <aside class="ticket-drawer">
        <div class="ticket-detail-header">
          <div>
            <div class="ticket-detail-id">{{ ticket.id }}</div>
            <h3>{{ ticket.title }}</h3>
            <p>Selected ticket details and available actions.</p>
          </div>
          <button class="btn ghost small" type="button" (click)="closeTicketPreview()">Close</button>
        </div>
        <div class="ticket-detail-summary">
          <span class="badge pill" [class]="statusClass(ticket.status)">
            {{ ticket.status }}
          </span>
          <span class="pill">{{ ticket.requestType }}</span>
          <span class="team-pill">{{ ticket.team }}</span>
          <span class="detail-meta">Updated {{ ticket.updated }}</span>
        </div>
        <div class="ticket-actions-panel">
          <button class="btn primary" type="button" (click)="viewTicket(ticket)">View Ticket</button>
          @if (canEditTicket(ticket)) {
            <button class="btn ghost" type="button" (click)="editTicket(ticket)">Edit ticket</button>
          }
          @if (showFollowAction && !isAdminRole() && !isDeveloperRole()) {
            <button class="btn ghost" type="button" (click)="toggleFollowTicket(ticket)">
              {{ ticket.followed ? 'Unfollow' : 'Follow' }} Ticket
            </button>
          }
          <button class="btn ghost" type="button" (click)="toggleLike(ticket)">
            {{ ticket.liked ? 'Unlike' : 'Like' }} Ticket
          </button>
          @if (isAdminRole() || isDeveloperRole()) {
            <button class="btn ghost" type="button" (click)="openTicketAction(ticket, 'actions')">
              Assign / Change Status
            </button>
          }
          <button class="btn ghost" type="button" (click)="openTicketAction(ticket, 'threads', 'comments')">
            Add Comment
          </button>
        </div>
      </aside>
    }
  </div>
</div>